import React from 'react';
import { AgentChat } from './components/AgentChat';
import './App.css';

function App() {
  return (
    <AgentChat />
  );
}

export default App;
